<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Архив партнеров</strong>
                </CCardHeader>

                <CCardBody>
                    <div class="table__preloader" v-if="loading && partners">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <CDataTable
                            hover
                            striped
                            sorter
                            column-filter
                            :items="filteredItems"
                            :fields="fields"
                            :items-per-page="itemsPerPage"
                            :active-page="activePage"
                            :pagination="{ doubleArrows: true, align: 'center'}"
                            @page-change="pageChange"
                            class="table__partners"
                        >
                            <template #title-filter>
                                <CInput
                                    v-model="titleFilter"
                                    class="mb-0"
                                    type="text"
                                    placeholder="Поиск по имени"
                                />
                            </template>
                            <template #enabled-filter>
                                <CSelect
                                    :value.sync="enabledFilter"
                                    :options="enabledFilterOptions"
                                    class="mb-0"
                                />
                            </template>
                            <template #title="data">
                                <td>
                                    <CLink :to="`/partners/${data.item.id}`">{{ data.item.title }}</CLink>
                                </td>
                            </template>
                            <template #enabled="data">
                                <td>
                                    <CBadge :color="getBadge(data.item.enabled)">
                                        {{ data.item.enabled ? 'Активен' : 'Неактивен' }}
                                    </CBadge>
                                </td>
                            </template>
                            <template #actions="data">
                                <td>
                                    <CButton
                                        color="success"
                                        size="sm"
                                        :disabled="actionId === data.item.id"
                                        @click="unarchivePartner(data.item)"
                                    >Убрать из архива</CButton>
                                </td>
                            </template>
                        </CDataTable>
                    </template>
                </CCardBody>
                <CCardFooter>
                    <CLink to="/partners">← К списку партнеров</CLink>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { unarchiveServiceItem } from '@/utils/archive';

    export default {
        name: 'PartnersArchive',

        data() {
            return {
                loading: true,
                partners: [],
                itemsPerPage: 30,
                titleFilter: '',
                enabledFilter: '',
                actionId: null,
                enabledFilterOptions: [
                    { value: '', label: 'Все' },
                    { value: 'true', label: 'Активен' },
                    { value: 'false', label: 'Не активен' },
                ],
                fields: [
                    { key: 'title', label: 'Название' },
                    { key: 'enabled', label: 'Активен' },
                    { key: 'actions', label: 'Действия', sorter: false, filter: false },
                ],
                activePage: 1,
            };
        },

        watch: {
            $route: {
                immediate: true,
                handler(route) {
                    if (route.query && route.query.page) {
                        this.activePage = Number(route.query.page);
                    }
                },
            },
        },

        async mounted() {
            this.loading = true;
            await Vue.axios
                .get('/partners', { params: { archive: true } })
                .then(resp => {
                    this.partners = resp.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            async unarchivePartner(partner) {
                if (!window.confirm(`Убрать «${partner.title}» из архива?`)) {
                    return;
                }

                this.actionId = partner.id;
                try {
                    await unarchiveServiceItem(Vue.axios, 'partners', partner);
                    this.partners = this.partners.filter(item => item.id !== partner.id);
                } catch (err) {
                    this.$root.$emit('showError', 'Не удалось убрать из архива.');
                } finally {
                    this.actionId = null;
                }
            },
            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
        },
        computed: {
            filteredItemsByEnabled() {
                if (this.enabledFilter === '') {
                    return this.partners;
                }
                const enabled = this.enabledFilter === 'true';
                return this.partners.filter(item => item.enabled === enabled);
            },
            filteredItems() {
                return this.filteredItemsByEnabled.filter(item =>
                    item.title.toLowerCase().includes(this.titleFilter.toLowerCase())
                );
            },
        },
    };
</script>

<style>
    .table__partners th,
    .table__partners td {
        padding: 0.75rem !important;
    }
</style>
